import queryString from 'query-string';
import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchCustomCards({ dispatch }, filters) {
  const queryParams = queryString.stringify(filters);

  return http.get(`${MINERVA_API_URL}/cards?${queryParams}`)
    .then((res) => {
      if (filters.offset === 0) {
        return dispatch('setCustomCardsInStore', res.data);
      }

      return dispatch('addCustomCardsInStore', res.data);
    })
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching custom cards:', err);
      return Promise.reject(err);
    });
}

export function fetchCustomCardDetails({ dispatch }, cardId) {
  return http.get(`${MINERVA_API_URL}/cards/${cardId}`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching custom card details:', err);
      return Promise.reject(err);
    });
}

export function fetchCustomCardPages({ dispatch }, cardId) {
  return http.get(`${MINERVA_API_URL}/cards/${cardId}/pages`)
    .then(res => (
      dispatch('setCustomCardPages', { cardId, pageList: res.data })
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching custom card pages:', err);
      return Promise.reject(err);
    });
}

export function setCustomCardsInStore({ commit }, cardList) {
  commit(types.SET_CARDS, cardList);

  return Promise.resolve(cardList);
}

export function addCustomCardsInStore({ commit }, cardList) {
  commit(types.ADD_CARDS, cardList);

  return Promise.resolve(cardList);
}

export function setSelectedCustomCardId({ commit }, cardId) {
  commit(types.SET_SELECTED, cardId);

  return Promise.resolve();
}

export function setCustomCardPages({ commit }, setInfo) {
  commit(types.SET_CARD_PAGES, setInfo);

  return Promise.resolve(setInfo.pageList);
}



// WEBPACK FOOTER //
// ./src/app/custom-cards/store/actions.js